// node modules
import React, { FC } from 'react';
import { observer } from 'mobx-react';
// components
import {
  TableCell,
  TableRow,
  Text,
} from '@upstox/upstox-ui';
import { useStore } from 'modules/Stores';
// utils
import { getHeaderColumns } from 'modules/OptionChain/components/OptionChainModal/components/OptionChainTableContainer/OptionChainTable/utils';
// styles
import * as css from './styles';
// typings
import { Props } from './typings';

const OptionChainTableHeader: FC<Props> = props => {
  const { type } = props;
  const { tableSettings } = useStore('OptionChainStore');
  const headerColumns = getHeaderColumns(tableSettings, type);
  const totalNoOfColumns = headerColumns.length;
  const isCall = type === 'CE';
  const keyPrefix = isCall ? 'call_header_' : 'put_header_';

  return (
    <TableRow css={css.rowContainer}>
      {!isCall && (
        <TableCell
          as="th"
          key={`${keyPrefix}separator`}
          css={css.actionCell}
          cssProps={{ isCall: false }}
        />
      )}
      {headerColumns.map(column => {
        const { label, subLabel } = column;
        return (
          <TableCell
            as="th"
            key={`${keyPrefix}${label}`}
            align="center"
            verticalAlign="middle"
            cssProps={{
              noOfCols: totalNoOfColumns,
              isLtpCell: label === 'LTP' || label === 'LTP',
            }}
            padding={[4]}
            css={css.optionChainTableHeaderCell}
          >
            <Text
              weight="bold"
              color="text.2"
              truncate
              size="m"
              lineHeight="xl"
            >
              {label}{' '}
            </Text>
            {subLabel && (
              <Text color="text.2" truncate size="s" lineHeight="xl">
                {subLabel}
              </Text>
            )}
          </TableCell>
        );
      })}
      {
        isCall && (
          <TableCell
            as="th"
            key={`${keyPrefix}separator`}
            css={css.actionCell}
            cssProps={{ isCall }}
          />
        )
      }
    </TableRow>
  );
};

export default React.memo(observer(OptionChainTableHeader));
